import * as React from "react";
import logo from "./kearney-logo-black.svg";

interface LogoProps {
	className?: string;
	height?: number;
	width?: number;
}

const Logo: React.FC<LogoProps> = ({ className, height = 20, width = 163 }) => (
	<img src={logo} alt="Kearney" className={className} height={height} width={width} />
);

export default Logo;
